export const B2B_PA17109_REALTOR_COMMISSION_KNOWLEDGE = 'b2b_pa17109_realtor_commission_knowledge';
export const B2B_CPN_NONE_OPERATIONAL_FUNNEL_ON_CPD_LANDING = 'b2b_cpd_non_operational_funnel_on_cpd_landing';
export const B2B_BUYER_LANDING_CHANGES = 'b2b_cpd_buyer_landing_changes';

export const EXPERIMENTS: string[] = [
  B2B_PA17109_REALTOR_COMMISSION_KNOWLEDGE,
  B2B_CPN_NONE_OPERATIONAL_FUNNEL_ON_CPD_LANDING,
  B2B_BUYER_LANDING_CHANGES,
];
